import { useMutation } from '@tanstack/react-query'
import { axiosInstance } from '@/modules/shared/lib/axios'

export interface PaymentCheckTestResult {
  reachable: boolean
  proxyEffective: boolean
  statusCode: number | null
  elapsedMs: number
  reason: string
  checkUrl: string
  proxyConfigured: boolean
  proxyHost: string | null
  bearerTokenConfigured: boolean
  responseSnippet: string
}

export function useMutationPaymentCheckTest() {
  return useMutation<PaymentCheckTestResult, unknown, void>({
    mutationFn: async () => {
      const { data } = await axiosInstance.post('/config-api/admin/payment-check/test')
      return data
    },
  })
}
